import { IDeleteEntity } from "interfaces/delete-entity";
import { GraphQLData } from "interfaces/graphql-data";
import { ITenant } from "interfaces/tenant";

export class DeleteFunctionModel implements IDeleteEntity, GraphQLData {
  lastEvaluatedKey: string = '';
  deleted: boolean = false;

  public static create(
    deleted: boolean) : DeleteFunctionModel {
    const t = new DeleteFunctionModel();
    t.deleted = deleted;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    //..
    // data.data.GetTenant.Deleted (true)
    console.log(data);
    if (data && data.data && data.data.GetFunction && data.data.GetFunction.Delete) {
      this.deleted = data.data.GetFunction.Delete;
    } else {
      throw new Error('data structured passed in does not contain data, data.data, data.data.GetMessageType or data.data.GetMessageType.Delete');
    }
  }
}